import { render, staticRenderFns } from "./RegionsList.vue?vue&type=template&id=18a805e3&"
import script from "./RegionsList.vue?vue&type=script&lang=js&"
export * from "./RegionsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('18a805e3')) {
      api.createRecord('18a805e3', component.options)
    } else {
      api.reload('18a805e3', component.options)
    }
    module.hot.accept("./RegionsList.vue?vue&type=template&id=18a805e3&", function () {
      api.rerender('18a805e3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/global/customDocuments/vistas/empresas/61221000-4/components/RegionsList.vue"
export default component.exports